import { useQuery } from '@tanstack/react-query'
import type { CardResponseDto } from '@lunary/api-client'
import { api } from '../api/client'

export function useCards() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['cards'],
    queryFn: () => api.get<CardResponseDto[]>('/cards'),
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
  return {
    cards: data ?? [],
    isPending,
    isError,
  }
}
